import {
    Elements,
    PaymentElement,
    useElements,
    useStripe,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import { Skeleton } from 'antd'
import { Loader, PushNotification } from 'components'
import { FormCheckBox } from 'elements'
import { GetOfferCartTermsAndCondition, useQueryString } from 'hooks'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import {
    BrowserUtility,
    BusinesService,
    NotificationStatus,
    NotificationText,
} from 'utility'

loadStripe.setLoadParameters({ advancedFraudSignals: false })
const TicketSummaryMain = styled.div`
    padding-top: 50px;
    .heading-main {
        display: flex;
        margin: 0px 150px;
        margin-bottom: 20px;
        justify-content: space-between;
        align-items: center;
    }
    .heading {
        font-weight: 700;
        font-size: 22px;
    }
    .ticket-details-main {
        background: #242631;
        border: 1.5px solid rgba(255, 255, 255, 0.1);
        border-radius: 14px;
        width: 77%;
        margin: 0 auto;
        padding: 20px;
        .skeleton {
            margin: 0.5rem 0rem;
            padding: 0;
            align-items: center;
            display: flex;
            justify-content: center;
        }
        .skeleton-div {
            width: calc(100% - 0.75rem);
            padding: 0.75rem;
            background-color: #30313d;
            border-radius: 5px;
            transition: background 0.15s ease, border 0.15s ease,
                box-shadow 0.15s ease, color 0.15s ease;
            border: 1px solid #424353;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5),
                0px 1px 6px rgba(0, 0, 0, 0.25);
        }
        .ant-skeleton,
        .ant-skeleton-input {
            width: 100% !important;
        }
    }
    .height-0 {
        height: 0 !important;
        overflow: hidden;
        opacity: 0;
    }
    .billing-address {
        font-weight: 700;
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .back-btn {
        width: 220px;
        margin-right: 10px;
        padding: 12px 12px;
        background: #4a4c5e;
        border-radius: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        cursor: pointer;
    }
    .next-btn {
        width: 220px;
        margin-left: 10px;
        padding: 12px 12px;
        background: #ff384e;
        border-radius: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        cursor: pointer;
    }
    .terms-condition-checkbox {
        display: flex;
        align-items: center;
        width: 77%;
        margin: 0 auto;
        margin-top: 20px;
        .terms-condition-text {
            color: #ff384e !important;
            cursor: Pointer;
        }
    }
    .note {
        width: 77%;
        margin: 0 auto;
        font-size: 14px;
        text-align: justify;
        padding-bottom: 20px;
        ul {
            li {
                color: #a6a6a6;
            }
        }
    }
    @media (min-width: 200px) and (max-width: 480px) {
        padding-top: 20px;
        .heading-main {
            margin: 0px 10px;
            margin-bottom: 10px;
            .heading {
                font-size: 20px;
            }
        }
        .note,
        .ticket-details-main {
            width: 100%;
        }
        .ticket-total-main {
            width: 100%;
        }
        .back-btn {
            width: 350px;
            margin-right: 0px;
            margin-bottom: 10px;
        }
        .next-btn {
            width: 350px;
            margin-left: 0px;
        }
        .user-info {
            margin: 0px 10px;
            margin-top: 10px;
            width: 100%;
        }
    }
    @media (min-width: 481px) and (max-width: 768px) {
        padding-top: 20px;
        .heading-main {
            margin: 0px 10px;
            margin-bottom: 10px;
            .heading {
                font-size: 20px;
            }
        }
        .note,
        .ticket-details-main {
            width: 100%;
        }
        .ticket-total-main {
            width: 100%;
        }
        .user-info {
            margin: 0px 10px;
            margin-top: 10px;
            width: 100%;
        }
    }
    @media (min-width: 769px) and (max-width: 1000px) {
        padding-top: 25px;
        .heading-main {
            margin: 0px 45px;
            margin-bottom: 10px;
            .heading {
                font-size: 20px;
            }
        }
        .note,
        .ticket-details-main {
            width: 90%;
        }
        .ticket-total-main {
            width: 90%;
        }
        .user-info {
            margin: 0px 45px;
            margin-top: 10px;
        }
    }
    @media (min-width: 1001px) and (max-width: 1200px) {
        .heading-main {
            margin: 0px 10px;
            margin-bottom: 10px;
            .heading {
                font-size: 20px;
            }
        }
        .note,
        .ticket-details-main {
            width: 100%;
        }
        .ticket-total-main {
            width: 100%;
        }
        .user-info {
            margin: 0px 10px;
            margin-top: 10px;
        }
    }
`
const DisplayType = {
    LINE: 'LINE',
}
export const CartConfirmScreen = () => {
    const { productBucketId } = useParams()
    const [showSkeleton, setShowSkeleton] = useState(true)
    const { data } = GetOfferCartTermsAndCondition(productBucketId)
    const { PaymentIntent, PublicKey } = useMemo(
        () => BrowserUtility.getObj(`product-buy-now-${productBucketId}`),
        [productBucketId],
    )
    loadStripe.setLoadParameters({ advancedFraudSignals: true })
    const stripePromise = PublicKey ? loadStripe(PublicKey) : null
    useEffect(() => {
        // let timeout = null
        // if (PaymentIntent) {
        //     timeout = setTimeout(() => setShowSkeleton(false), 5000)
        // }
        // return () => {
        //     if (timeout) clearTimeout(timeout)
        // }
    }, [PaymentIntent])
    return (
        <TicketSummaryMain className="container">
            <div className="heading-main">
                <div className="heading">Purchase Summary</div>
            </div>
            {showSkeleton && <PaymentSkeleton />}
            {PaymentIntent && (
                <Elements
                    stripe={stripePromise}
                    options={{
                        ...PaymentIntent,
                        appearance: {
                            theme: 'night',
                            labels: 'floating',
                        },
                        wallets: {
                            applePay: 'auto',
                            googlePay: 'never',
                        },
                        paymentMethodOrder: ['card'],
                        paymentMethods: {
                            card: {
                                showIcon: true,
                                icon: 'visa',
                                disabled: true,
                            },
                        },
                        clientSecret: PaymentIntent.ClientSecretId,
                    }}
                    onChange={event => console.log(event)}
                >
                    <CheckoutForm
                        showSkeleton={showSkeleton}
                        eventData={PaymentIntent.MetaData}
                        setShowSkeleton={setShowSkeleton}
                    />
                </Elements>
            )}
            <div className="note">
                <span>Notes:-</span>
                <ul>
                    <li>
                        Please avoid submitting twice or pressing the back
                        button while processing your request. This may result in
                        duplicate submissions or errors.
                    </li>
                    <li>
                        Please wait for the confirmation message after clicking
                        the submit button and refrain from navigating away from
                        this page until the process is complete. Thank you for
                        your cooperation!
                    </li>
                </ul>
            </div>
            <div className="note">
                {data?.map(item => (
                    <>
                        <span className="text-white" key={item.title}>
                            {item.Title}:-
                        </span>
                        <ul>
                            {item.DisplayType === DisplayType.LINE ? (
                                <li>
                                    {item.Details.map(ele => (
                                        <li key={ele.Detail}>{ele.Detail}</li>
                                    ))}
                                </li>
                            ) : (
                                <p>
                                    {item.Details.map(ele => (
                                        <span key={ele.Detail}>
                                            {ele.Detail}
                                        </span>
                                    ))}
                                </p>
                            )}
                        </ul>
                    </>
                ))}
            </div>
        </TicketSummaryMain>
    )
}

export const CheckoutForm = ({ showSkeleton, setShowSkeleton }) => {
    const stripe = useStripe()
    // const { setOptions } = useStripe();
    const elements = useElements()
    const { productBucketId } = useParams()
    const { storetype } = useQueryString()
    const [loading, setLoading] = useState(false)
    const [tnc, setTnc] = useState(false)
    const navigate = useNavigate()
    const handleSubmit = async event => {
        if (!tnc) {
            PushNotification(
                NotificationText.TNCIsRequired,
                NotificationStatus.error,
            )
            return
        }
        event.preventDefault()
        if (!stripe || !elements || !tnc) {
            return
        }
        setLoading(true)

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/product-success/${productBucketId}`,
            },
            redirect: 'if_required',
        })
        console.log('Stripe result ==> ', result)
        if (result.error) {
            PushNotification(result.error.message, NotificationStatus.error)
        } else if (
            result.paymentIntent &&
            result.paymentIntent.status === 'succeeded'
        ) {
            const orderRes = await BusinesService.confirmOrder(storetype, {
                ProductBucketId: productBucketId,
            })
            if (orderRes?.Result) {
                navigate(`/qr/order-sucess/${productBucketId}`, {
                    state: { orderRes },
                })
            }
        } else {
            PushNotification(
                'Something went wrong please try again',
                NotificationStatus.error,
            )
        }
        setLoading(false)
    }
    const clickOnBack = () => {
        navigate(-1)
    }
    return (
        <div className={`${showSkeleton && ' height-0'}`}>
            <form onSubmit={handleSubmit}>
                <div className="ticket-details-main">
                    <PaymentElement
                        options={{
                            phone_number_collection: {
                                enabled: true,
                            },
                            wallets: {
                                applePay: 'auto',
                                googlePay: 'never',
                            },
                        }}
                        onLoaderStart={() => setShowSkeleton(true)}
                        onLoadError={() => setShowSkeleton(false)}
                        onReady={() => setShowSkeleton(false)}
                    />
                </div>
                <FormCheckBox
                    className="terms-condition-checkbox"
                    value={tnc}
                    onChange={e => setTnc(e.target.checked)}
                >
                    I have read and agree to the{' '}
                    <span
                        className="terms-condition-text"
                        onClick={() => window.open('/term-condition', '_blank')}
                    >
                        Terms and Condition{' '}
                    </span>{' '}
                    of GTikit.
                </FormCheckBox>
                <div className="row justify-content-center my-4 pb-4 pt-2">
                    <div
                        className="next-btn mt-3 mx-1"
                        disabled={!stripe || !tnc}
                        onClick={handleSubmit}
                    >
                        <span>Submit</span>
                    </div>
                    <div className="back-btn mt-3 mx-1" onClick={clickOnBack}>
                        <span>Back</span>
                    </div>
                </div>
            </form>
            <Loader loading={loading} />
        </div>
    )
}

const PaymentSkeleton = () => {
    return (
        <>
            <div className="ticket-details-main">
                <div className="row mx-0 px-0">
                    <div className="col-6 skeleton">
                        <div className="skeleton-div">
                            <Skeleton.Input active />
                        </div>
                    </div>
                    <div className="col-6 skeleton">
                        <div className="skeleton-div">
                            <Skeleton.Input active />
                        </div>
                    </div>
                </div>
                <div className="row mx-0 px-0">
                    <div className="col-12 skeleton">
                        <div className="skeleton-div">
                            <Skeleton.Input active />
                        </div>
                    </div>
                </div>
                <div className="row mx-0 px-0">
                    <div className="col-6 skeleton">
                        <div className="skeleton-div">
                            <Skeleton.Input active />
                        </div>
                    </div>
                    <div className="col-6 skeleton">
                        <div className="skeleton-div">
                            <Skeleton.Input active />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center my-4 pb-4 pt-2">
                <div className="back-btn">
                    <Skeleton.Input active />
                </div>
                <div className="next-btn">
                    <Skeleton.Input active />
                </div>
            </div>
        </>
    )
}
